import React from 'react';
import { Section, SectionHeader } from '../ui/Section';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const benefits = ['Aprende de los grandes genios de la historia', 'Desarrolla pensamiento crítico', 'Inspira tu mente', 'Ideal para estudiar o escuchar', 'Educación profunda y accesible', 'Contenido curado por expertos'];
export function BenefitsSection() {
  return <Section background="brown" className="relative overflow-hidden" data-id="element-8">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-[#C9A227] rounded-full blur-[150px] opacity-10 pointer-events-none" data-id="element-9"></div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-10">
        <div data-id="element-11">
          <SectionHeader title="Beneficios Transformadores" subtitle="Más que información, una nueva forma de ver el mundo." centered={false} light={true} data-id="element-12" />

          <div className="space-y-6" data-id="element-13">
            {benefits.map((benefit, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} className="flex items-start" data-id="element-14">
                <CheckCircle2 className="w-6 h-6 text-[#C9A227] mt-1 mr-4 flex-shrink-0" data-id="element-15" />
                <span className="text-xl text-[#E0D8D0] font-light" data-id="element-16">
                  {benefit}
                </span>
              </motion.div>)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        x: 50
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="relative" data-id="element-17">
          <div className="absolute inset-0 border-2 border-[#C9A227] transform translate-x-4 translate-y-4 rounded-lg" data-id="element-18"></div>
          <img src="https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?auto=format&fit=crop&q=80&w=1000" alt="Estudio y aprendizaje" className="rounded-lg shadow-2xl relative z-10 w-full grayscale hover:grayscale-0 transition-all duration-700" data-id="element-19" />
        </motion.div>
      </div>
    </Section>;
}